import React from 'react';
import { privacyPolicy, termsOfService, type LegalDocument } from '../data/legal';
interface FooterProps {
  onOpenLegal: (doc: LegalDocument) => void;
}
export function Footer({
  onOpenLegal
}: FooterProps) {
  return <footer className="w-full border-t border-bark/10 bg-cream py-12 sm:py-16" data-id="element-105" data-mp="32ovvqqc38li1">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-106" data-mp="36oxw8w6378vq">
        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" aria-label="Enlaces legales" data-id="element-107" data-mp="36nd75m2jki59">
          <button type="button" onClick={() => onOpenLegal(privacyPolicy)} className="text-sm font-medium text-bark underline decoration-bark/25 underline-offset-4 transition-colors duration-150 ease-out hover:text-clay focus:outline-none focus-visible:ring-2 focus-visible:ring-clay" data-id="element-108" data-mp="38qvaxf23pqn">
            Políticas de privacidad
          </button>
          <button type="button" onClick={() => onOpenLegal(termsOfService)} className="text-sm font-medium text-bark underline decoration-bark/25 underline-offset-4 transition-colors duration-150 ease-out hover:text-clay focus:outline-none focus-visible:ring-2 focus-visible:ring-clay" data-id="element-109" data-mp="29y5g5yj5lgty">
            Términos y condiciones
          </button>
        </nav>

        <div className="mt-10 space-y-4 text-xs leading-relaxed text-ink/65" data-id="element-110" data-mp="3v7q63q00qlg1">
          <p data-id="element-111" data-mp="3v5n5yd55jbxl">
            <strong className="font-semibold text-ink/80" data-id="element-112" data-mp="3v5dgqrrxl8sy">Descargo de responsabilidad:</strong> este
            sitio no forma parte de Facebook, Instagram ni de Meta Platforms, Inc., y no está
            patrocinado, avalado ni administrado por ellos. FACEBOOK™ e INSTAGRAM™ son marcas
            registradas de Meta Platforms, Inc.
          </p>
          <p data-id="element-113" data-mp="hrs7jgp4s76n">
            Código Cortisol es un producto digital de carácter educativo. El contenido no constituye
            consejo médico, diagnóstico ni tratamiento y no sustituye la consulta con un profesional
            de la salud. Si estás embarazada, en lactancia, tomas medicación o tienes una condición
            metabólica u hormonal, consulta a tu médico antes de aplicar cambios en tu alimentación
            o en tus hábitos.
          </p>
          <p data-id="element-114" data-mp="yu7hysrlhryq">
            Los testimonios reflejan experiencias individuales y no constituyen una garantía de
            resultados. Los resultados varían según cada persona. Pago único, sin suscripciones ni
            cargos recurrentes; los precios se muestran en USD y la pasarela de pago realiza la
            conversión a moneda local antes de confirmar la compra.
          </p>
          <p data-id="element-115" data-mp="1cnyp5uhuszra">
            Consultas y soporte:{' '}
            <a href="mailto:nutrinaturalonline@gmail.com" className="font-medium text-bark underline decoration-bark/25 underline-offset-2 transition-colors duration-150 ease-out hover:text-clay" data-id="element-116" data-mp="1hjnqo3dfoqq8">
              nutrinaturalonline@gmail.com
            </a>
          </p>
          <p className="pt-2 text-ink/50" data-id="element-117" data-mp="3obexrtubnece">
            © 2026 Código Cortisol. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}